import PropTypes from 'prop-types';
import styles from './SidebarContainer.module.scss';
import TocMobileMenu from '../TableOfContentsMobileMenu';
/**
 * A container with sidebar. Useful for adding navigation to a page
 */
export default function SidebarContainer({
  children, sidebar, fullScreen, flipped, mobileMenuProps, mobileMenuEnabled,
}) {
  const containerClassName = [
    styles['sidebar-container__container'],
    fullScreen ? styles['--full-screen'] : '',
    flipped ? styles['--flipped'] : '',
  ].join(' ').trim();

  return (
    <div className={styles['sidebar-container']}>
      <div className={containerClassName}>
        <div className={styles['sidebar-container__sidebar']}>
          {sidebar}
        </div>
        <div className={styles['sidebar-container__content']}>
          {children}
        </div>
      </div>
      {mobileMenuEnabled && (
        <TocMobileMenu {...mobileMenuProps}>
          {sidebar}
        </TocMobileMenu>
      )}
    </div>
  );
}

SidebarContainer.defaultProps = {
  children: null,
  flipped: false,
  fullScreen: true,
  sidebar: null,
  mobileMenuProps: {},
  mobileMenuEnabled: false,
};

SidebarContainer.propTypes = {
  children: PropTypes.node,
  /**
   * Swap sidebar and content
   */
  flipped: PropTypes.bool,
  /**
   * Is the block fullscreen or is it rendered in another container?
   */
  fullScreen: PropTypes.bool,
  sidebar: PropTypes.node,
  /**
   * Props for mobile menu
   */
  mobileMenuProps: PropTypes.shape({
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.bool,
    activeSection: PropTypes.string,
    top: PropTypes.bool,
    left: PropTypes.bool,
    defaultTitle: PropTypes.bool,
  }),
  /**
   * Should mobile menu be rendered?
   */
  mobileMenuEnabled: PropTypes.bool,
};
